var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#E0F3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6242_55068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8213 43.0976C50.2383 43.0976 47.7393 42.6776 45.4083 41.9216C44.6733 41.6696 43.8543 41.8586 43.2873 42.4256L39.9903 46.5626C34.0473 43.7276 28.4823 38.3726 25.5213 32.2196L29.6163 28.7336C30.1833 28.1456 30.3513 27.3266 30.1203 26.5916C29.3433 24.2606 28.9443 21.7616 28.9443 19.1786C28.9443 18.0446 27.9993 17.0996 26.8653 17.0996H19.5993C18.4653 17.0996 17.1003 17.6036 17.1003 19.1786C17.1003 38.6876 33.3333 54.8996 52.8213 54.8996C54.3123 54.8996 54.9003 53.5766 54.9003 52.4216V45.1766C54.9003 44.0426 53.9553 43.0976 52.8213 43.0976Z",
    fill: "#1A9CC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6242_55068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.4,
    height: 50.4,
    fill: "white",
    transform: "translate(10.8003 10.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.bf0b07d6f678ea23b3371641f4e9dce3.svg";
export { ForwardRef as ReactComponent };